export default __webpack_public_path__ + "static/media/theme.ac57c771.svg";